<template>
  <div id="SysPermissionList">
    <eb-header>
      <eb-break-crumb slot='breakCrumb' />
      <eb-search @search-click='loadPermissionListDataBySearchWord' slot='search' />
    </eb-header>
    <div class="box-header">
      <div class="box-header-right">
        <el-button @click="showAddPremWindow" class="eb-button-red eb-button-small">新增</el-button>
        <el-button :disabled="isEditStatus" @click="showEditPremWindow" class="eb-button-red eb-button-small">修改</el-button>
        <el-button :disabled="isDelStatus" @click="deletePrem" class="eb-button-red eb-button-small">删除</el-button>
      </div>
    </div>
    <div class="table-box eb-table">
        <el-table :data="pageData.permissionList" :stripe="true" @current-change='handleCurrentRowChange' style="width: 100%">
          <el-table-column label='选中' width='55'>
            <template slot-scope='scope'>
              <el-radio class='radio' v-model='radioValue' :label='scope.$index'>&nbsp;</el-radio>
            </template>
          </el-table-column>
          <el-table-column sortable prop="permCode" label="权限编码" width="110"></el-table-column>
          <el-table-column sortable prop="permName" label="权限名称"></el-table-column>
          <el-table-column sortable prop="permUrl" label="权限URl" width="110"></el-table-column>
          <el-table-column sortable prop="permDesc" label="权限描述" width="110"></el-table-column>
          <el-table-column sortable prop="dassiontapermi" label="权限类型" width="110">
            <template slot-scope='scope'>
              {{scope.row.dassiontapermi|permiStatus}}
            </template>
          </el-table-column>
          <el-table-column sortable prop="authorName" label="开发人员" width="110"></el-table-column>
          <el-table-column sortable prop="creatorName" label="创建人" width="110"></el-table-column>
          <el-table-column sortable prop="updatetime" label="更新时间" width="130">
            <template slot-scope='scope'>
              {{scope.row.createDate|dateTimeStandardFormat}}
            </template>
          </el-table-column>
          <el-table-column property='stauts' label="操作" width="100">
            <template slot-scope="scope">
              <template>
                <a @click="showEditPermRoleWindow(scope.row.permId)" href="javascript:void(0)" class="a-font-red">编辑角色</a>
              </template>
            </template>
          </el-table-column>
        </el-table>
    </div>
    <eb-pagination class="pagination" :current-page.sync="searchParams.start" v-if="searchParams.length" @current-change="onPageChange"
      :total="pageData.recordsTotal" />
    <PermissionDialog @onSuccess="onSuccess" :isVisible.sync='dialogVisible' :permInfo='permInfo' />
    <EditPermRoleDialog :isVisible.sync='roleDialogVisible' :permRoleList='permRoleList' :permId='permId' />
  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ebSearch from '@/components/common/eb-search';
import EbPagination from '@/components/common/eb-pagination/eb-pagination';
import PermissionDialog from '@/components/sys/PermissionDialog';
import EditPermRoleDialog from '@/components/sys/EditPermRoleDialog';
import { clone } from 'lodash';
import { listPermissionList, delPermission, permRoleList } from '@/services/system-service';
export default {
  components: {
    ebHeader,
    ebBreakCrumb,
    ebSearch,
    EbPagination,
    PermissionDialog,
    EditPermRoleDialog
  },
  data() {
    return {
      initSearchParams: {
        length: 10,
        start: 1
      },
      searchParams: null,
      pageData: {
        permissionList: [],
        recordsTotal: 0
      },
      isEditStatus: true,
      isDelStatus: true,
      dialogVisible: false,
      radioValue: null,
      permInfo: {
        dialogVisible: false,
        operType: 'add',
        permId: null,
        permCode: null,
        permName: null,
        permUrl: null,
        permDesc: null,
        authorName: null,
        dassiontapermi: null
      },
      roleDialogVisible: false,
      permRoleList: [],
      permId: null
    };
  },
  computed: {
    paginationSize() {
      return this.pageData.recordsTotal / this.searchParams.length;
    }
  },
  created() {
    this.searchParams = clone(this.initSearchParams);
    this.loadPermissionListData();
  },
  methods: {
    // 搜索操作
    loadPermissionListDataBySearchWord(text) {
      this.searchParams.content = text;
      this.loadPermissionListData();
    },
    // 当前页改变操作
    onPageChange(pageNum) {
      this.searchParams.start = pageNum;
      this.loadPermissionListData();
    },
    async loadPermissionListData() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await listPermissionList(this.searchParams);
        this.pageData.recordsTotal = data.recordsTotal;
        this.pageData.permissionList = data.data;
      } catch (error) {
        this.$message.error('加载权限列表失败');
      }
      this.$root.layout.isLoading = false;
    },
    handleCurrentRowChange: function(currRow) {
      this.radioValue = this.pageData.permissionList.indexOf(currRow);
      this.currentSelectedRow = currRow;
      if (this.currentSelectedRow) {
        this.isEditStatus = false;
        this.isDelStatus = false;
      }
    },
    // 添加
    showAddPremWindow() {
      this.dialogVisible = true;
      this.permInfo.operType = 'add';
      this.permInfo.permId = null;
      this.permInfo.permCode = null;
      this.permInfo.permName = null;
      this.permInfo.permUrl = null;
      this.permInfo.permDesc = null;
      this.permInfo.authorName = null;
      this.permInfo.dassiontapermi = null;
    },
    // 修改
    showEditPremWindow() {
      if (!this.currentSelectedRow) {
        this.$message.error('请选择一条数据进行操作');
        return;
      }
      this.permInfo.permId = this.currentSelectedRow.permId;
      this.permInfo.permCode = this.currentSelectedRow.permCode;
      this.permInfo.permName = this.currentSelectedRow.permName;
      this.permInfo.permUrl = this.currentSelectedRow.permUrl;
      this.permInfo.permDesc = this.currentSelectedRow.permDesc;
      this.permInfo.authorName = this.currentSelectedRow.authorName;
      this.permInfo.dassiontapermi = this.currentSelectedRow.dassiontapermi;
      this.permInfo.operType = 'edit';
      this.dialogVisible = true;
    },
    // 删除
    deletePrem() {
      if (!this.currentSelectedRow) {
        this.$message.warning('请选择要删除的权限');
      } else {
        this.$ebConfirm('确认删除？').then(async result => {
          this.$root.layout.isLoading = true;
          try {
            let { data } = await delPermission(this.currentSelectedRow.permId);
            if (data.returnCode === '01') {
              this.loadPermissionListData();
              this.isDelStatus = true;
              this.$message.success('删除成功');
            }
          } catch (error) {
            this.$message.error('删除失败');
          }
          this.$root.layout.isLoading = false;
        });
      }
    },
    async showEditPermRoleWindow(permId) {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await permRoleList(permId);
        if (data.returnCode === '01') {
          this.permRoleList = data.data;
          this.permId = permId;
          this.roleDialogVisible = true;
        }
      } catch (error) {
        this.$message.error('加载角色失败');
      }

      this.$root.layout.isLoading = false;
    },
    onSuccess: function() {
      this.loadPermissionListData();
    }
  }
};
</script>

<style  scoped lang='less'>
#SysPermissionList {
  .a-font-red {
    color: red;
    text-decoration: underline !important;
  }
}
</style>
